<template>
    <div>
        <SchemaOrgQuestion
            v-if="product.faqs && product.faqs.length"
            v-for="item in product.faqs"
            :name="item.question"
            :accepted-answer="item.answer"
        />
    </div>
</template>

<script lang="ts" setup>
import type { IProduct } from "~/libs/types/api/product";

const route = useRoute();

const props = defineProps({
    product: {
        type: Object as PropType<IProduct>,
        required: true,
    },
});

defineOgImageComponent("Main", {
    title: props.product.name,
    description: props.product.about,
    image: props.product?.feature_image ? Object.values(props.product?.feature_image)[0]?.original_url : undefined,
    path: route.fullPath,
});

useSeoMeta({
    title: props.product.seo?.title ? `${props.product.seo.title} | نرس‌لند` : `${props.product.name} | رستری قهوه نرس‌لند`,
    description: props.product.seo?.description ?? props.product.about,
    robots: props.product.seo?.robots ?? "index, follow",
    canonical: `https://northland-co.com/product/${props.product.slug}`,
    ogTitle: props.product.seo?.og_title ?? props.product.name,
    ogDescription: props.product.seo?.og_description ?? props.product.about,
    ogType: "product",
    ogUrl: `https://northland-co.com/product/${props.product.slug}`,
    twitterCard: "summary_large_image",
});
</script>

<style></style>
